import { FormGroup } from '@angular/forms'

export type SignupFormType = SignupFormProxy & FormGroup

export class SignupFormProxy {
  public constructor(private _form: FormGroup) {
    return new Proxy(_form, { get: this._handler.bind(this) }) as SignupFormType
  }

  public isInvalidControl(controlName: string): boolean {
    const control = this._form.get(controlName)
    return control.invalid && (control.dirty || control.touched)
  }

  // Overwrites function retrieval calls
  private _handler(_object, name): Function {
    return this[name] || this._form[name]
  }
}
